/**
 * 根据本地连接/本地文件下载（Blob URL/File对象）
 * @param {string|File} source - 本地连接（Blob URL，如 blob:http://xxx）或 File对象（用户选中的本地文件）
 * @param {string} [fileName] - 下载文件名（不传则用File对象原名/自动生成）
 */
export function downloadLocalSource(source, fileName) {
  try {
    let downloadUrl = "";
    let finalFileName = fileName;

    // 场景1：处理File对象（用户通过<input type="file">选中的本地文件）
    if (source instanceof File) {
      downloadUrl = URL.createObjectURL(source);
      // 若未传文件名，使用File对象的原始名称
      finalFileName = finalFileName || source.name;
    }
    // 场景2：处理Blob URL（本地生成的临时链接）
    else if (typeof source === "string" && source.startsWith("blob:")) {
      downloadUrl = source;
      // 若未传文件名，自动生成默认名称
      finalFileName = finalFileName || "local-file";
    }
    // 不支持的类型（如直接的file://路径，浏览器禁止）
    else {
      alert(
        "仅支持Blob URL或用户选中的本地File对象下载，禁止直接访问本地文件路径！",
      );
      return;
    }

    // 核心下载逻辑
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = finalFileName;
    link.click();

    // 清理资源（仅File对象生成的Blob URL需要释放）
    if (source instanceof File) {
      URL.revokeObjectURL(downloadUrl);
    }
  } catch (err) {
    alert("下载失败：" + err.message);
  }
}
